export default __webpack_public_path__ + "static/media/BAT-BAKE.b22f416f.svg";